/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {APP_SHARED} from '../common/app-shared';
import {AdvertiserEarningsWidgetComponent} from './widget/advertiser-earnings-widget.component';
import {BarChartWidgetComponent} from './widget/bar-chart-widget.component';
import {ExternalIframeWidgetComponent} from './widget/external-iframe-widget.component';
import {HtmlInsertionWidgetComponent} from './widget/html-insertion-widget.component';
import {LineItemListWidgetComponent} from './widget/line-item-list-widget.component';
import {OrderListWidgetComponent} from './widget/order-list-widget.component';
import {StatsWidgetComponent} from './widget/stats-widget.component';
import {TreeMapWidgetComponent} from './widget/tree-map-widget.component';

@Component({
  standalone: true,
  imports: [
    ...APP_SHARED,
    AdvertiserEarningsWidgetComponent,
    BarChartWidgetComponent,
    ExternalIframeWidgetComponent,
    HtmlInsertionWidgetComponent,
    LineItemListWidgetComponent,
    OrderListWidgetComponent,
    StatsWidgetComponent,
    TreeMapWidgetComponent
  ],
  selector: 'adn-workspace-widget-host',
  template: `
    @switch (widgetDirective) {
      @case ('adnStatsWidget') {
        <adn-stats-widget [widgetType]="widget"></adn-stats-widget>
      }
      @case ('adnBarChartWidget') {
        <adn-bar-chart-widget [widgetType]="widget"></adn-bar-chart-widget>
      }
      @case ('adnTreeMapWidget') {
        <adn-tree-map-widget [widgetType]="widget"></adn-tree-map-widget>
      }
      @case ('adnLineItemList') {
        <adn-line-item-list-widget [widgetType]="widget"></adn-line-item-list-widget>
      }
      @case ('adnOrderList') {
        <adn-order-list-widget [widgetType]="widget"></adn-order-list-widget>
      }
      @case ('adnAdvertiserEarningsList') {
        <adn-advertiser-earnings-widget [widgetType]="widget"></adn-advertiser-earnings-widget>
      }
      @case ('adnHtmlInsertion') {
        <adn-html-insertion-widget [widgetType]="widget"></adn-html-insertion-widget>
      }
      @case ('adnWidgetIframe') {
        <adn-external-iframe-widget [widgetType]="widget"></adn-external-iframe-widget>
      }
    }
  `
})
export class WorkspaceWidgetHostComponent {
  @Input() widget: any;

  get widgetDirective(): string {
    return this.widget?.systemDefined?.widget;
  }
}
